import {
    OG_LOCALES,
    SITE_URL,
    buildAlternateUrls,
    buildCanonicalUrl
} from './language';

const MANAGED_ATTR = 'data-seo';

const upsertMeta = (attr, key, content) => {
    if (!content) return;
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        tag.setAttribute(MANAGED_ATTR, 'true');
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
};

const upsertCanonical = (url) => {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }
    link.setAttribute('href', url);
};

const rebuildAlternates = (path, language) => {
    document.head
        .querySelectorAll('link[rel="alternate"][hreflang], meta[property="og:locale:alternate"]')
        .forEach((node) => node.remove());

    const alternates = buildAlternateUrls(path);

    alternates.forEach(({ hreflang, url }) => {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', hreflang);
        link.setAttribute('href', url);
        link.setAttribute(MANAGED_ATTR, 'true');
        document.head.appendChild(link);
    });

    const xDefault = document.createElement('link');
    xDefault.setAttribute('rel', 'alternate');
    xDefault.setAttribute('hreflang', 'x-default');
    xDefault.setAttribute('href', buildCanonicalUrl('uz', path));
    xDefault.setAttribute(MANAGED_ATTR, 'true');
    document.head.appendChild(xDefault);

    alternates
        .filter((alternate) => alternate.language !== language)
        .forEach(({ language: alternateLanguage }) => {
            const meta = document.createElement('meta');
            meta.setAttribute('property', 'og:locale:alternate');
            meta.setAttribute('content', OG_LOCALES[alternateLanguage]);
            meta.setAttribute(MANAGED_ATTR, 'true');
            document.head.appendChild(meta);
        });
};

/**
 * Единая точка, где страница объявляет себя поисковикам:
 * title, description, canonical, hreflang, Open Graph, <html lang>.
 */
export const applySeo = ({
    language,
    path = '/',
    title,
    description,
    ogType = 'website',
    ogImage = `${SITE_URL}/hero-bg1.webp`,
    noindex = false
}) => {
    const canonical = buildCanonicalUrl(language, path);

    if (title) document.title = title;
    document.documentElement.setAttribute('lang', language);

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', ogType);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:locale', OG_LOCALES[language]);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);

    upsertCanonical(canonical);
    rebuildAlternates(path, language);

    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
        upsertMeta('name', 'robots', 'noindex, follow');
    } else if (robots) {
        robots.remove();
    }
};

/**
 * Structured data конкретной страницы. Статическая разметка организации
 * в index.html не трогается — этот блок живёт отдельно и снимается
 * при уходе со страницы (см. cleanup в useEffect).
 */
export const setPageJsonLd = (data) => {
    let script = document.head.querySelector('script[data-seo-jsonld="page"]');

    if (!data) {
        if (script) script.remove();
        return;
    }

    if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-jsonld', 'page');
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
};
